import { FC } from "react";
import { StyledBasePill } from "./BasePill";

type Props = {
  color?: string;
  bgColor?: string;
  className?: string;
  testId?: string;
  id?: string;
};

export const CustomPill: FC<Props> = ({
  children,
  color = "var(--color-neutral-000-full)",
  bgColor = "var(--color-primary-500)",
  ...props
}) => (
  <StyledBasePill {...props} color={color} bgColor={bgColor}>
    {children}
  </StyledBasePill>
);
